import module from 'viaticos/module.js'
import template from './template.html'

export class ViaticosSharedAnticiposAnticipoComponent {
  desplegar = false
  mostrar_editar = false
  solicitudId

  constructor (ViaticosViaticoAnticiposAnticipoService) {
    this.ViaticosViaticoAnticiposAnticipoService = ViaticosViaticoAnticiposAnticipoService
  }

  $onInit () {
    this.promise = this.ViaticosViaticoAnticiposAnticipoService.get(this.solicitudId)
      .then(({data}) => {
        this.data = data
      })
  }

  editar (importe) {
    this.data.importe = importe
    this.mostrar_editar = false
  }
}

module.component('viaticosSharedAnticiposAnticipo', {
  controller: ViaticosSharedAnticiposAnticipoComponent,
  template,
  bindings: {
    solicitudId: '<',
  },
})




// WEBPACK FOOTER //
// ./src/viaticos/components/shared/anticipos/anticipo/component.js